document.addEventListener('DOMContentLoaded', function() {
  const emblaNodes = document.querySelectorAll('.ecs-related-articles .embla');
  if (!emblaNodes.length) return;

  emblaNodes.forEach((emblaNode, index) => {
    const emblaApi = EmblaCarousel(emblaNode, {
      align: 'start',
      loop: false,
      slidesToScroll: 1,
      containScroll: 'trimSnaps'
    });

    const slides = emblaApi.slideNodes();
    const parentSection = emblaNode.closest('.ecs-related-articles');
    const dotsContainer = parentSection.querySelector('.ecs-related-articles__dots');
    const prevButton = parentSection.querySelector('.ecs-related-articles__arrow--prev');
    const nextButton = parentSection.querySelector('.ecs-related-articles__arrow--next');

    const setActiveClass = () => {
      const selectedIndex = emblaApi.selectedScrollSnap();
      slides.forEach((slide, index) => {
        slide.classList.toggle('active', index === selectedIndex);
      });
      updateDots(selectedIndex);
    };

    const updateDots = (selectedIndex) => {
      if (!dotsContainer) return;
      const dots = dotsContainer.querySelectorAll('.ecs-related-articles__dot');
      dots.forEach((dot, index) => {
        dot.classList.toggle('is-selected', index === selectedIndex);
      });
    };

    const toggleNavigationVisibility = (numberOfDots) => {
      if (dotsContainer) {
        dotsContainer.style.display = numberOfDots <= 1 ? 'none' : '';
      }
      if (prevButton) {
        prevButton.style.display = numberOfDots <= 1 ? 'none' : '';
      }
      if (nextButton) {
        nextButton.style.display = numberOfDots <= 1 ? 'none' : '';
      }
    };

    const createDots = () => {
      if (!dotsContainer) return;
      dotsContainer.innerHTML = '';
      
      let slidesPerView = 1;
      let slidesToScroll = 1;
      if (window.innerWidth >= 1024) {
        slidesPerView = 3;
        slidesToScroll = 1;
      } else if (window.innerWidth >= 750) {
        slidesPerView = 2;
        slidesToScroll = 1;
      }
      
      const totalSlides = slides.length;
      const numberOfDots = Math.max(1, totalSlides - slidesPerView + 1);
      
      for (let i = 0; i < numberOfDots; i++) {
        const dot = document.createElement('div');
        dot.classList.add('ecs-related-articles__dot');
        dot.addEventListener('click', () => emblaApi.scrollTo(i));
        dotsContainer.appendChild(dot);
      }
      
      toggleNavigationVisibility(numberOfDots);
    };

    createDots();
    setActiveClass();
    emblaApi.on('select', setActiveClass);

    prevButton?.addEventListener('click', () => emblaApi.scrollPrev());
    nextButton?.addEventListener('click', () => emblaApi.scrollNext());

    window.addEventListener('resize', () => {
      createDots();
      setActiveClass();
    });
  });
}); 